/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicReservedInstance extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicReservedInstance");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicReservedInstance.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicReservedInstance>): BackgroundJobPayloadForPeriodicReservedInstance {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicReservedInstance(), model);
        BackgroundJobPayloadForPeriodicReservedInstance.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicReservedInstance>): BackgroundJobPayloadForPeriodicReservedInstance {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicReservedInstance.newInstance(<BackgroundJobPayloadForPeriodicReservedInstance> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicReservedInstance) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicReservedInstance.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicReservedInstance): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicReservedInstance.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
